import { Component } from '@theme/component';
import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph, MORPH_OPTIONS } from '@theme/morph';

class AnticipatedShipDateComponent extends Component {
  /** @type {Element | null} */
  #variantUpdateRoot = null;

  connectedCallback() {
    super.connectedCallback();
    this.#variantUpdateRoot =
      this.closest('quick-add-dialog') ??
      this.closest('featured-product-information') ??
      this.closest('[data-testid="product-information"]') ??
      this.closest('[id*="ProductInformation-"]') ??
      this.closest('[id^="shopify-section-"]');
    if (!this.#variantUpdateRoot) return;
    this.#variantUpdateRoot.addEventListener(ThemeEvents.variantUpdate, this.updateAnticipatedShip);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#variantUpdateRoot?.removeEventListener(ThemeEvents.variantUpdate, this.updateAnticipatedShip);
    this.#variantUpdateRoot = null;
  }

  /**
   * @param {VariantUpdateEvent} event
   */
  updateAnticipatedShip = (event) => {
    if (event.detail.data.morphedMain) return;

    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const html = event.detail.data.html;
    if (!html) return;

    const next = html.querySelector(`anticipated-ship-date[data-product-id="${this.dataset.productId}"]`);
    if (!next) return;

    morph(this, next, MORPH_OPTIONS);
  };
}

if (!customElements.get('anticipated-ship-date')) {
  customElements.define('anticipated-ship-date', AnticipatedShipDateComponent);
}
